
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/Radar/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["radar-demo-common","radar-demo-markdown","radar-demo-category"],
  getter: () => import(/* webpackChunkName: "meta__Radar__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/Radar/index.en.md?type=demo')
};